import React from 'react';
import { Switch } from 'react-router-dom';
import { componentService } from 'js/services/component.service';

export const PageRoute = React.lazy(() => import(/* webpackChunkName: "page-route" */ './PageRoute'));

// <hub2-page-route><span></span></hub2-page-route>
componentService.registerWebContentComponents({
    PageRoute,
    PageRouteSwitch: Switch
});
